export const entryMethods = {
  form: "form",
  keyword: "keyword",
  checkin: "checkin",
};

export const entryOptions = [
  { label: "Form", value: entryMethods.form, translation_key: "common:form" },
  {
    label: "Keyword (No registration form!)",
    value: entryMethods.keyword,
    translation_key: "mixer:wizard:entry_method_keyword",
  },
  // { label: "Check-in", value: "checkin" },
];
